export default __webpack_public_path__ + "static/media/rocket-uniform.836fa8d6.png";